<div class="row" *ngIf="person">
  <json-edit
    [object]="person"
    [processing]="processing"
    [type]="'Person'"
    (toggleSave)="savePerson($event)"
    (toggleCancel)="cancel()"
  ></json-edit>
</div>
